export const IconCross = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<polygon
				fill="currentColor"
				fillRule="evenodd"
				points="5.05 3.636 9.999 8.586 14.95 3.636 16.364 5.05 11.413 10 16.364 14.95 14.95 16.364 9.999 11.414 5.05 16.364 3.636 14.95 8.584 10 3.636 5.05"
			/>
		</svg>
	);
};
